import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';
import { ITEMIZATION_WIDGET_ACTION } from "../actions/itemizationWidgetActions";

export function fetchItemizationWidgetData(uuid, translations, dateFormat, measurementType) {
  return dispatch => {
    axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + uuid + '/itemization-widget-data', {
      params: {
        "measurement-type": measurementType,
        "date-format": dateFormat
      }
    }).then(
      (response) => {
        dispatch({
          type: ITEMIZATION_WIDGET_ACTION.FETCH_DATA_SUCCESS,
          payload: {
            data: response.data.payload,
            translations: translations
          }
        })
      },
      (error) =>{
        dispatch({
          type: ITEMIZATION_WIDGET_ACTION.FETCH_DATA_FAILED,
          payload: {
            error: error,
            translations: translations
          }
        })
      }
    )
  }
}